import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import {type Post} from 'mattermost-redux/types/posts';
import {useAppSelector} from 'stores/redux_store';
import {makeCreateAriaLabelForPost} from 'utils/post_utils';

type Props = React.HTMLProps<HTMLDivElement> & {
    labelPrefix?: string;
    post: Post;
}

const PostAriaLabelDiv = React.forwardRef((props: Props, ref: React.Ref<HTMLDivElement>) => {
    const {
        children,
        labelPrefix,
        post,
        ...otherProps
    } = props;

    const intl = useIntl();

    const createAriaLabelForPost = useMemo(() => makeCreateAriaLabelForPost(), []);
    let ariaLabel = useAppSelector((state) => createAriaLabelForPost(state, post)(intl));
    if (labelPrefix) {
        ariaLabel = labelPrefix + ariaLabel;
    }

    return (
        <div
            ref={ref}
            aria-label={ariaLabel}
            {...otherProps}
        >
            {children}
        </div>
    );
});

PostAriaLabelDiv.displayName = 'PostAriaLabelDiv';

export default PostAriaLabelDiv;
